import React from 'react';
import {
    ModalContentWrapper,
    SelectDiv,
    TickersSelectWrapper,
    TickersTitle,
    TopElementsDiv
} from "./cPSettingsBlockStyles";
import CPList from "./CPList";


const scrollStyles = {
    backgroundColor: '#7CBE7B',
    width: '6px',
    borderRadius: '10px'
}

const CPSettingsBlock = ({ CPData, onRemove, id }: any) => {
    
    return (
        <ModalContentWrapper>
            <TickersSelectWrapper>
                <TopElementsDiv>
                    <TickersTitle>
                        Название
                    </TickersTitle>
                    <TickersTitle>
                        Значение
                    </TickersTitle>
                </TopElementsDiv>
                <SelectDiv
                    thumbSize={60}
                    renderThumbVertical={(props: any) => (
                        <div {...props} style={{
                            ...props.style,
                            ...scrollStyles,
                        }}/>
                    )}
                >
                    <CPList
                    onRemove={onRemove}
                    CPData={CPData}
                    id = { id }
                    />
                </SelectDiv>
            </TickersSelectWrapper>
        </ModalContentWrapper>
    );
};

export default CPSettingsBlock;
